/* tslint:disable */
/* eslint-disable */
/**
 * e-SNRWB
 * Opis api e-SNRWB
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateKwzHistoryDto
 */
export interface CreateUpdateKwzHistoryDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateKwzHistoryDto
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateKwzHistoryDto
     */
    ts: Date;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateKwzHistoryDto
     */
    kwzId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateKwzHistoryDto
     */
    activity: string;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateKwzHistoryDto
     */
    date: Date;
}

export function CreateUpdateKwzHistoryDtoFromJSON(json: any): CreateUpdateKwzHistoryDto {
    return CreateUpdateKwzHistoryDtoFromJSONTyped(json, false);
}

export function CreateUpdateKwzHistoryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateKwzHistoryDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'ts': (new Date(json['ts'])),
        'kwzId': json['kwzId'],
        'activity': json['activity'],
        'date': (new Date(json['date'])),
    };
}

export function CreateUpdateKwzHistoryDtoToJSON(value?: CreateUpdateKwzHistoryDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'ts': (value.ts.toISOString()),
        'kwzId': value.kwzId,
        'activity': value.activity,
        'date': (value.date.toISOString()),
    };
}


